import React from 'react';

const MainModalFooter = ({ footer }) => {
  return <div className="modalMimicPageModalFooter">{footer ? footer : null}</div>;
};

export default MainModalFooter;
